module.exports = __webpack_public_path__ + "static/media/affordable-catering-hero.30e23cf8.jpg";